export const OAuthMessageType = {
  Ready: 'oauth_ready',
  Result: 'oauth_result',
  Error: 'oauth_error',
  PortTransfer: 'oauth_port_transfer',
} as const;

/** OAuth popup page paths, relative to the TPA base URL. */
export const OAuthPaths = {
  /** The initializer page the popup opens on. */
  Init: '/oauth/init.html',
  /** The handler page the provider redirects back to; its URL is the `redirect_uri` registered with providers. */
  CallbackPage: '/oauth/callback.html',
} as const;

export const SessionStorageKeys = {
  OpenerOrigin: 'oauth_openerOrigin',
  State: 'oauth_state',
} as const;

export type OAuthError =
  | { type: 'popupBlocked' }
  | { type: 'timeout' }
  | { type: 'closedEarly' }
  | { type: 'stateMismatch' }
  | { type: 'providerError'; message: string }
  | { type: 'handshakeFailed'; message: string };

export interface OAuthCallbackParams {
  code?: string;
  state?: string;
  error?: string;
}
